/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-console */
import React, { useState } from "react";
import { Drawer } from "antd";
import { useSelector } from "react-redux";
import CloseIcon from "../../../Common/Svgs/CloseIcon";
import FilterItem from "../../../Core/Components/FilterItem";
import { TIME_FILTER } from "../constants";
import TimeFilter from "../HubDetails/TimeFilter";
import CustomTable from "../../../Core/Components/CustomTable";
import PlugIcon from "../../../Common/Svgs/PlugIcon";
import { chargingHistoryColumns, chargingHistoryData } from "./constants";
import ChevronIcon from "../../../Common/Svgs/ChevronIcon";

const LOCAL_DEFAULT_LIMIT = 10;

const ChargingHistoryDrawer = ({ visible, onCancel }) => {
  const { currentCharger } = useSelector((state) => state.hubs);

  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState({
    energySource: [],
  });
  const [timeFilter, setTimeFilter] = useState({
    id: TIME_FILTER.TODAY,
    value: "today",
    custom: [],
  });

  const onSelect = (key, value) => {
    // whenever applying the filter, the page should be defaulted back to first page
    setCurrentPage(1);

    if (filters[key].includes(value)) {
      const newFilters = filters[key].filter((item) => item !== value);
      setFilters({ ...filters, [key]: newFilters });
    } else {
      setFilters({ ...filters, [key]: [...filters[key], value] });
    }
  };

  return (
    <Drawer
      width={672}
      placement="right"
      closable={false}
      maskStyle={{
        background: "transparent",
        boxShadow: "12px 12px 16px -4px #10182814",
      }}
      open={visible}
      onClose={onCancel}
      className="rounded-tl-xl"
    >
      <div className="w-full h-full bg-background-white rounded-tl-xl relative">
        <div className="pt-6 flex items-center justify-between px-6">
          <div className="flex items-center gap-x-3">
            <p className="font-poppins font-medium text-base text-black">
              {currentCharger?.id}
            </p>

            <div className="bg-green h-[26px] flex items-center justify-center px-2 rounded-md">
              <p className="font-poppins text-xs font-medium text-background-white">
                Active
              </p>
            </div>
          </div>

          <CloseIcon
            className="w-5 h-5 cursor-pointer stroke-dark-gray"
            onClick={onCancel}
          />
        </div>

        <div className="mt-4 px-6 flex items-center justify-between">
          <p className="font-aileron text-xs font-normal text-dark-gray">
            Charging History
          </p>

          <div className="flex items-center">
            <FilterItem
              label="Energy Source"
              identifier="energySource"
              contentData={[]}
              onSelect={onSelect}
              customValue
              selectedValues={filters.energySource}
              className="max-h-[200px] overflow-y-scroll"
            />

            <TimeFilter
              filter={timeFilter}
              setFilter={setTimeFilter}
              variant="charging-history"
            />
          </div>
        </div>

        <div className="transaction-history mt-4">
          <CustomTable
            disableScroll
            columns={chargingHistoryColumns}
            data={chargingHistoryData}
            emptyState={<PlugIcon size={16} className="text-dark-grey-text" />}
            pagination={{
              pageSize: LOCAL_DEFAULT_LIMIT,
              total: chargingHistoryData.length,
              showSizeChanger: false,
              onChange: (page) => {
                setCurrentPage(page);
              },
              current: currentPage,
              itemRender: (current, type, originalElement) => {
                const lastPage = chargingHistoryData.length / current;

                if (type === "prev" && current === 0) {
                  return (
                    <button
                      type="button"
                      className="-rotate-180 rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
                      style={{
                        pointerEvents: "none",
                      }}
                    >
                      <ChevronIcon className="stroke-dark-gray" />
                    </button>
                  );
                }

                if (type === "prev" && current > 0) {
                  return (
                    <button
                      type="button"
                      className="-rotate-180 rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
                    >
                      <ChevronIcon className="stroke-dark-gray" />
                    </button>
                  );
                }

                if (type === "next" && lastPage <= 10) {
                  return (
                    <button
                      type="button"
                      className="rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
                      style={{ pointerEvents: "none" }}
                    >
                      <ChevronIcon className="stroke-dark-gray" />
                    </button>
                  );
                }

                if (type === "next") {
                  return (
                    <button
                      type="button"
                      className="rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
                    >
                      <ChevronIcon className="stroke-dark-gray" />
                    </button>
                  );
                }

                return originalElement;
              },
            }}
          />
        </div>
      </div>
    </Drawer>
  );
};

export default ChargingHistoryDrawer;
